export default {"src":"/_next/static/media/CloseModalIcon.5e0f63d8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};